export const BASE_ENDPOINT = {
  Schools: 'bases/Schools',
  GetSchoolStudents: 'bases/Schools/{baseId}/Students',
  GetTermAndAcademicYear: 'bases/Schools/{schoolId}/AcademicYearsAndTerms'
};
